import uniqBy from 'lodash/uniqBy';
import isEmpty from 'lodash/isEmpty';

import { LOCK_CLAIM, LOCK_RELEASE } from './const.js';

export default (state = {}, action)=> { 

  switch (action.type) {

  case LOCK_CLAIM:{
    const {    
      userId,
      name,
      emailAddress,
      sessionId

    } = action;

    return {
      ...state,
      lock: {
        userId,
        name,
        emailAddress,
        sessionId
        
      }
    };
  }


  case LOCK_RELEASE: {
    return {
      ...state,
      lock:null,
      prevLocks: isEmpty(state.lock) ?
        state.prevLocks
      :
        [ ...(state.prevLocks || []), state.lock]
    };
  }

  default:
    return state;
  }
};


export const getLockCurrentUserData = (state)=>
  state.me;

export const getLockData = (state)=>
  state.lock;

export const getUniquePreviousLocks = (state)=>
  uniqBy(state.prevLocks, 'userId');